import {
    ActionTypes
} from "../type";

const initialState = {
    showObservationRangeForm: false,
    observationRangeFormData: [],
    isInternalObservationOpen: false
}

export const observationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SHOW_OBSERVATION_RANGE_FORM:
            return {
                ...state, showObservationRangeForm: action.payload
            }
        case ActionTypes.SET_OBSERVATION_RANGE_FORM_DATA:
            return {
                ...state, observationRangeFormData: action.payload
            }
        case ActionTypes.SET_IS_INTERNAL_OBSERVATION_OPEN:
            return {
                ...state, isInternalObservationOpen: action.payload
            }
            default:
                return state;
    }
}